export default __webpack_public_path__ + "media/images/ico-small-business-8f50a8ccb352df694524737cbbf0ba49.svg";